import React from "react";

import { Route, Redirect } from "react-router-dom";

let ProtectedLayout = (componentProps) => {
    return (
        <Route {...componentProps}
            render={(props) => {
                if (componentProps.isUserLogged) {
                    return (<componentProps.Component {...props} />);
                }
                else {
                    return (<Redirect to={{ pathname: "/", state: { from: props.location } }} />)
                }
            }}
        />
    );
};

export default ProtectedLayout;